export const USER = {
  LOGIN: {
    FAILED: 'USER_LOGIN_FAILED',
    SUCCESSFUL: 'USER_LOGIN_SUCCESSFUL'
  },
  PASSWORD: {
    FORGOT: {
      FAILED: 'USER_PASSWORD_FORGOT_FAILED',
      RESET: 'USER_PASSWORD_FORGOT_RESET'
    },
    RESET: {
      ACCESS_GRANTED: 'USER_PASSWORD_RESET_ACCESS_GRANTED',
      FAILED: 'USER_PASSWORD_RESET_FAILED'
    }
  },
  RESET: 'USER_RESET'
}

export const LAW_FIRMS = {
  INIT: 'LAW_FIRMS_INIT',
  UPDATE_SELECTED: 'LAW_FIRMS_UPDATE_SELECTED',
  RESET: 'LAW_FIRMS_RESET'
}

export const DRIVE = {
  SET: 'DRIVE_SET',
  ADD_FILE: 'DRIVE_FILE_ADD',
  SET_SELECTED_NODE: 'DRIVE_SET_SELECTED_NODE',
  SET_UPLOAD_FILES: 'DRIVE_SET_UPLOAD_FILES',
  DELETE_FILE: 'DRIVE_DELETE_FILE',
  RESET: 'DRIVE_RESET'
}
